import { render, staticRenderFns } from "./ServerAndClient.vue?vue&type=template&id=b09ebb06&lang=pug&"
import script from "./ServerAndClient.vue?vue&type=script&lang=ts&"
export * from "./ServerAndClient.vue?vue&type=script&lang=ts&"
import style0 from "./ServerAndClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports